
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Legal() {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Legal Information</h1>
          
          {/* Terms of Use Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Terms of Use</h2>
            <div className="prose prose-gray max-w-none">
              <h3 className="text-xl font-medium text-gray-800 mb-4">1. Acceptance of Terms</h3>
              <p className="text-gray-600 mb-4">
                By accessing and using the services of MY MARKETING HORIZON LIMITED, you accept and agree to be bound by the terms and provision of this agreement.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">2. Services</h3>
              <p className="text-gray-600 mb-4">
                MY MARKETING HORIZON LIMITED provides digital marketing services including but not limited to Google Ads management, social media advertising, native advertising campaigns, and analytics optimization.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">3. Client Responsibilities</h3>
              <p className="text-gray-600 mb-4">
                Clients are responsible for providing accurate information, timely feedback, and maintaining compliance with all applicable advertising policies and regulations.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">4. Payment Terms</h3>
              <p className="text-gray-600 mb-4">
                All services are subject to agreed payment terms. Late payments may result in service suspension. Refunds are handled on a case-by-case basis according to our refund policy.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">5. Limitation of Liability</h3>
              <p className="text-gray-600 mb-4">
                MY MARKETING HORIZON LIMITED shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services.
              </p>
            </div>
          </section>

          {/* Privacy Policy Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Privacy Policy</h2>
            <div className="prose prose-gray max-w-none">
              <h3 className="text-xl font-medium text-gray-800 mb-4">1. Information We Collect</h3>
              <p className="text-gray-600 mb-4">
                We collect information you provide directly to us, such as when you create an account, request services, or contact us. This may include your name, email address, company information, and marketing preferences.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">2. How We Use Your Information</h3>
              <p className="text-gray-600 mb-4">
                We use the information we collect to provide, maintain, and improve our services, communicate with you, and comply with legal obligations.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">3. Information Sharing</h3>
              <p className="text-gray-600 mb-4">
                We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy or as required by law.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">4. Data Security</h3>
              <p className="text-gray-600 mb-4">
                We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">5. Your Rights</h3>
              <p className="text-gray-600 mb-4">
                You have the right to access, update, or delete your personal information. You may also opt out of certain communications from us.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">6. Cookies</h3>
              <p className="text-gray-600 mb-4">
                We use cookies and similar technologies to enhance your experience, analyze usage, and assist in our marketing efforts.
              </p>
            </div>
          </section>

          {/* Legal Information Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Legal Information</h2>
            <div className="prose prose-gray max-w-none">
              <h3 className="text-xl font-medium text-gray-800 mb-4">Company Details</h3>
              <div className="bg-gray-50 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-2"><strong>Company Name:</strong> MY MARKETING HORIZON LIMITED</p>
                <p className="text-gray-700 mb-2"><strong>Registered Address:</strong> 50 Princes Street, Ipswich, IP1 1RJ</p>
                <p className="text-gray-700 mb-2"><strong>Company Number:</strong> 16646875</p>
                <p className="text-gray-700 mb-2"><strong>Contact Email:</strong> contact@my-marketinghorizon.com</p>
              </div>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">Governing Law</h3>
              <p className="text-gray-600 mb-4">
                These terms and conditions are governed by and construed in accordance with the laws of England and Wales.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">Dispute Resolution</h3>
              <p className="text-gray-600 mb-4">
                Any disputes arising from these terms or our services shall be subject to the exclusive jurisdiction of the courts of England and Wales.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">Intellectual Property</h3>
              <p className="text-gray-600 mb-4">
                All content, trademarks, and intellectual property on this website are owned by MY MARKETING HORIZON LIMITED or our licensors.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-4">Changes to Terms</h3>
              <p className="text-gray-600 mb-4">
                We reserve the reason to modify these terms at any time. Changes will be effective immediately upon posting on this website.
              </p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-8">
            <p className="text-sm text-gray-500">
              Last updated: {new Date().toLocaleDateString('en-GB', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
